import { render, staticRenderFns } from "./tagsList.vue?vue&type=template&id=716e3428&scoped=true"
import script from "./tagsList.vue?vue&type=script&lang=js"
export * from "./tagsList.vue?vue&type=script&lang=js"
import style0 from "./tagsList.vue?vue&type=style&index=0&id=716e3428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e3428",
  null
  
)

export default component.exports